import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner';
import { SvgModule } from '@ui/svg/svg.module';

@NgModule({
  imports: [CommonModule, SvgModule],
  declarations: [SpinnerComponent],
  exports: [SpinnerComponent],
})
export class SpinnerModule {}
